






































import { GenerationUnitsFeedbackFormGroupContent } from '@/api/interfaces/content/form/steps/powerConnection/GenerationUnitsFeedbackFormGroupContent';
import FormScriptButton from '@/components/molecules/formScriptButton/FormScriptButton.vue';
import FormTextBlock from '@/components/molecules/formTextBlock/FormTextBlock.vue';
import { getFormInputMixin } from '@/mixins/formInputMixin';
import { GenerationUnitsFeedbackFormGroup } from '@/types/forms/formGroups/powerConnection/GenerationUnitsFeedbackFormGroup';
import { ConnectionRulesType } from '@/types/forms/shared/connectionRulesType';
import { InvalidGenerationUnit } from '@/types/forms/shared/invalidGenerationUnit';
import { ApplicationForm } from '@/types/forms/specific/applicationForm';
import Vue, { PropType } from 'vue';

export default getFormInputMixin<
    GenerationUnitsFeedbackFormGroup,
    GenerationUnitsFeedbackFormGroupContent,
    unknown,
    ApplicationForm
>().extend({
    name: 'GenerationUnitsFeedbackFormGroup',
    components: {
        FormTextBlock,
        FormScriptButton,
    },
    inject: {
        editStep: {
            from: 'editStep',
        },
        scrollToStep: {
            from: 'scrollToStep',
        },
    },
    props: {
        invalidGenerationUnits:
            (Array as PropType<InvalidGenerationUnit[]>) ?? [],
    },
    computed: {
        /** Whether to show the form group, based on the same conditions as the disabling rules */
        show(): boolean {
            return (
                this.invalidGenerationUnits.length > 0 &&
                this.invalidGenerationUnits.some((unit) =>
                    unit.norm.some(
                        (norm) => norm === ConnectionRulesType.rules4105,
                    ),
                )
            );
        },
    },
    methods: {
        /**
         * Opens the plant performance step in edit mode
         */
        openPlantPerformanceFormStep(
            this: Vue & {
                editStep: (identifier: string) => void;
                scrollToStep: (identifier: string) => void;
            },
        ): void {
            this.editStep('plantPerformance');
            this.scrollToStep('plantPerformance');
        },
    },
});
